import script from "./userDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./userDropdown.vue?vue&type=script&setup=true&lang=js"

import "./userDropdown.vue?vue&type=style&index=0&id=2f06c700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f06c700"]])

export default __exports__